import React, { useState, useEffect, useContext } from "react";
import Dialog from '@mui/material/Dialog';
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import DataTable from "react-data-table-component";
import Button from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { dico } from "variables/lists/dico";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { plan2dItemText, dashboardText } from "variables/MBM/geb";
import { definitionData, controlmodeData, stateData } from "variables/MBM/lists/equipments";

import { overwritevaluestranslation } from "variables/lists/dico";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { NotificationManager } from "react-notifications";
import CustomSelectWithIcon from "components/Input/CustomSelectWithIcon";
import ViewIotDialog from "./ViewIotDialog";
import { equipmenttext, pointtext } from "variables/MBM/equipments";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "axios";
import UserService from "services/UserService";
import { getSchedules, getPoints, getGEBScripts } from "services/ConfigServices";
import PointDialog from "../Control/Equipments/PointDialog";
import PointOverrideDialog from "../Control/Equipments/PointOverrideDialog";
import ScheduleDialog from "../Control/Schedules/ScheduleDialog";
import ViewPointDataDialog from "../Plans/ViewPointDataDialog";
import CustomSwitch from "components/Input/CustomSwitch.js";
import moment from "moment";
import { Pilotage, Override, Data as DataIcon } from "components/CustomIcon/CustomIcon";
import 'moment/locale/fr';
import ScriptDialog from "../Control/Scripts/ScriptDialog";
import ThermostatWidget from "components/CustomWidget/Control/ThermostatWidget";

const useStyles2 = makeStyles(styles);


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  "@keyframes flicker": {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0.7
    }
  },
  flicker: {
    animationName: "$flicker",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out"
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? "paused" : "running"
  })
}));

const Title = styled.div`
text-align: center;
margin-top: 21px;
font-size: 20px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 15px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 15px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  cursor: pointer;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const Data = styled.div`
font-size: 15px;
font-weight: 600;
opacity: 1;
font-family: "Source Sans Pro", sans-serif;
`;
const DataMargin = styled.div`
font-size: 15px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const LinkCell = styled.div`
  font-weight: 600;
  cursor: pointer;
`;
const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.1rem 1rem;
  margin-bottom: 0.6rem;
  
`;
const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};



function ViewEquipmentDialog(props) {
  const currentusertype = localStorage.getItem('userType');
  const classes2 = useStyles2();
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const mbm_geb_control_access = permis.includes("mbm_geb_control_access");
  const mbm_geb_control_admin_override = permis.includes("mbm_geb_control_admin_override");
  const classes = useStyles();
  const { currentItem, iots, equipments, plan, fullpoints, wpgroup, currentEquipment,
    pointdata, planrawdata, plan1ddata, plan1hdata, refetchfullpoints, workspace, fromiot } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const [displayWidget, setDisplayWidget] = useState(false);

  const [equipment, setEquipment] = useState(currentEquipment || "");
  const [iot, setIot] = useState("");
  const [openIot, setOpenIot] = useState(false);
  const [equipmentpoints, setEquipmentpoints] = useState([]);
  const [point, setPoint] = useState(null);
  const [openPoint, setOpenPoint] = useState(false);
  const [openPointOverride, setOpenPointOverride] = useState(false);
  const [openPointData, setOpenPointData] = useState(false);
  const [schedulesData, setSchedulesData] = useState([]);
  const [openSchedule, setOpenSchedule] = useState(false);
  const [openScript, setOpenScript] = useState(false);

  const [showadvanced, setShowadvanced] = useState(false);
  const [currentSchedule, setCurrentSchedule] = useState(null);
  const [currentScript, setCurrentScript] = useState(null);

  const [scriptData, setScriptData] = useState([]);

  const handleOpeniot = (event) => { setOpenIot(true); };
  const handleCloseiot = (event) => { setOpenIot(false); };
  const handleOpenSchedule = (event) => { setOpenSchedule(true); };
  const handleCloseSchedule = (event) => { setOpenSchedule(false); };
  const handleOpenScript = (event) => { setOpenScript(true); };
  const handleCloseScript = (event) => { setOpenScript(false); };

  const { chartIdGroup } = advancedSearchContext;

  useEffect(() => {
    if (wpgroup > 0) {
      getGroupSchedules();
    }
  }, [wpgroup]);

  useEffect(() => {
    if (!currentEquipment) {
      let eqtmp = equipments.find((i) => i.id == currentItem.parameters?.equipment);
      if (eqtmp) {
        setEquipment(eqtmp);
      }
    }
  }, []);

  const getGroupSchedules = () => {
    axios
      .get(
        getSchedules(wpgroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpSchedulesData = res.data.schedules?.map((data) => {
          return (
            { name: data.parameters.name, id: data.id, destination: data.destination, schedule: data, parameters: data.parameters }
          );
        });
        setSchedulesData(tmpSchedulesData || []);
      });
    axios
      .get(
        getGEBScripts(workspace.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpScriptData = res.data.scripts?.map((data) => {
          return (
            { name: data.parameters.name, id: data.id, destination: data.destination, script: data }
          );
        });
        setScriptData(tmpScriptData || []);
      });
  }

  const getEquipmentPoints = (id) => {
    axios
      .get(
        getPoints(null, null, id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (currentItem) {
          let displayedpoints = currentItem.parameters?.displayedpoints || [];
          let equipmentpointstmp = res.data.points.filter((p) => {
            if (!displayedpoints.find((point) => point.id == p.id) ||
              (displayedpoints.find((point) => point.id == p.id).display === 'true'))
              return true;
            else
              return false;
          });
          setEquipmentpoints(equipmentpointstmp);
        }
        else
          setEquipmentpoints(res.data.points);
      })
      .catch(() => { });
  }

  useEffect(() => {
    if (equipment.connectionproperties?.iotdevice) {
      let iottmp = iots.find((i) => i.id == equipment.connectionproperties.iotdevice);
      if (iottmp) {
        setIot(iottmp);
      }
    }
    getEquipmentPoints(equipment.id);
    // let equipmentpointstmp = fullpoints.filter((p) => p.equipment == equipment.id);
    // setEquipmentpoints(equipmentpointstmp);
  }, [equipment]);

  const editPoint = (row) => async () => {
    let obj = fullpoints.find((o) => o.id === row.id);
    if (obj) {
      obj.equipmentName = equipment.name;
      obj.displayproperties = row.displayproperties;
      setPoint(obj);
      handleViewPointOpen();
    }
  }
  const editPointOverride = (row) => async () => {
    let obj = fullpoints.find((o) => o.id === row.id);
    if (obj) {
      obj.equipmentName = equipment.name;
      obj.displayproperties = row.displayproperties;
      setPoint(obj);
      handleViewPointOverrideOpen();
    }
  }
  const viewPointData = (row) => async () => {

    let obj = pointdata.find((o) => o.id === row.id);
    // console.log(pointdata, row, obj);
    setPoint(obj);
    handleViewPointDataOpen();
  };

  const handleViewPointOpen = () => {
    setOpenPoint(true);
  };
  const handleViewPointClose = () => {
    setOpenPoint(false);
  };
  const handleViewPointOverrideOpen = () => {
    setOpenPointOverride(true);
  };
  const handleViewPointOverrideClose = () => {
    setOpenPointOverride(false);
  };
  const handleViewPointDataOpen = () => {
    setOpenPointData(true);
  };
  const handleViewPointDataClose = () => {
    setOpenPointData(false);
  };
  const handleShowadvancedChange = () => {
    setShowadvanced(!showadvanced);
  };

  const editSchedule = (row) => async () => {
    let obj = schedulesData.find((o) => o.id === row.schedule);
    if (obj) {
      setCurrentSchedule(obj.schedule);
      handleOpenSchedule();
    }
  }

  const editScript = (row) => async () => {
    let obj = scriptData.find((o) => o.id === row.script);
    if (obj) {
      setCurrentScript(obj.script);
      handleOpenScript();
    }
  }

  const refetchSchedules = () => {
    getGroupSchedules();
  }
  const refetchPoint = () => {
    getEquipmentPoints(equipment.id);
    refetchfullpoints();
  }
  const isinoverride = (row) => {
    let inoverride = false;
    if (row.overridestate && row.overridestate.begin && row.overridestate.end) {
      if (moment(row.overridestate.begin).isSameOrBefore(moment()) && moment(row.overridestate.end).isSameOrAfter(moment()))
        inoverride = true;
    }
    return inoverride;
  }


  const conditionalRowStyles = [
    {
      when: row => row.state == 1,
      style: {
        backgroundColor: '#6B3CC8',
        color: 'white',
      },
    },
  ];
  const pointscolumns = [
    {
      name: pointtext.name,
      selector: (row) => row.name,
      sortable: true,
      width: "14rem",
      cell: (row) => row.name,
    },
    // {
    //   name: pointtext.definition,
    //   selector: (row) => row.definition,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => dico.find((x) => x.id == row.definition)?.name || ""
    // },
    {
      name: pointtext.state,
      selector: (row) => row.state,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => stateData.find((x) => x.id == row.state)?.name || ""
    },
    {
      name: pointtext.controlmode,
      selector: (row) => row.controlmode,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => controlmodeData.find((x) => x.id == row.controlmode)?.name || ""
    },
    {
      name: pointtext.controlval,
      selector: (row) => row.schedule,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.controlmode === 1 ? (schedulesData.find((x) => x.id == row.schedule) ?
        <LinkCell onClick={editSchedule(row)}>{schedulesData.find((x) => x.id == row.schedule).name}</LinkCell> : "")
        : row.controlmode === 0 ? ((row.displayproperties?.overwritevalues && row.formula?.text && row.displayproperties?.overwritevalues["" + row.formula.text]) ?
          overwritevaluestranslation.find((r) => r.id === row.displayproperties.overwritevalues["" + row.formula.text])?.name || row.displayproperties.overwritevalues["" + row.formula.text]
          : row.formula?.text ? row.formula.text : "")
          : row.controlmode === 2 ? (scriptData.find((x) => x.id == row.script) ?
            <LinkCell onClick={editScript(row)}>{scriptData.find((x) => x.id == row.script).name}</LinkCell> : "") : ""
    },
    // {
    //   name: pointtext.lastdate,
    //   selector: (row) => row.lastdate,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) =>
    //     row.lastdate && moment(row.lastdate).isValid()
    //       ? moment(row.lastdate).format("DD/MM/YYYY HH:mm")
    //       : "",
    // },
    {
      name: pointtext.lastvalue,
      selector: (row) => row.lastvalue,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.lastvalue ? (row.displayproperties?.overwritevalues && row.displayproperties?.overwritevalues["" + row.lastvalue]) ?
        overwritevaluestranslation.find((r) => r.id === row.displayproperties.overwritevalues["" + row.lastvalue])?.name || row.displayproperties.overwritevalues["" + row.lastvalue]
        : isNaN(row.lastvalue.replace(",", ".")) ? row.lastvalue : new Intl.NumberFormat('fr-FR').format(row.lastvalue.replace(",", ".")) : ""
    },
    // {
    //   name: pointtext.unit,
    //   selector: (row) => row.definition,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => dico.find((x) => x.id == row.definition)?.unit || ""
    // },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (

        <>

          <div className="actions-right">
            <Tooltip title="Voir les données">
              <Button
                onClick={viewPointData(row)}
                color={"info"}
                className={classes2.actionButton}
              >
                <DataIcon fontSize="large" />
              </Button>
            </Tooltip>
            {(mbm_geb_control_schedules && row.controlable) && (
              <>
                <Tooltip title="Règles de pilotage">
                  <Button
                    onClick={editPoint(row)}
                    color={"warning"}
                    className={classes2.actionButton}
                  >
                    <Pilotage fontSize="large" />
                  </Button>
                </Tooltip>
                {(row.state === 1 && (currentusertype == 1 || mbm_geb_control_admin_override)) &&
                  <Tooltip title={isinoverride(row) ? "Dérogation de consigne - Dérogation en cours" : "Dérogation de consigne"}>
                    <Button
                      onClick={editPointOverride(row)}
                      color={"warning"}
                      className={isinoverride(row) ? classes2.actionButton + " " + classes.flicker : classes2.actionButton}
                    >
                      <Override fontSize="large" />
                    </Button>
                  </Tooltip>
                }
              </>
            )}
          </div>
        </>
      ),
    },
  ];


  return (
    <>
      <Title>{currentItem?.parameters?.name || ""}</Title>
      {
        displayWidget ?
          <ThermostatWidget>

          </ThermostatWidget> :

          <DialogContent>
            <form className={classes.root}>
              <GridContainer style={{ width: 'min-content' }}>
                <GridItem xs={12} sm={12} md={6} lg={6}>
                  <DataList>
                    <DataContainer>
                      <Data>{plan2dItemText.associatedequipment + " : "}</Data>
                      <DataResult>{equipment?.name || ""}</DataResult>
                    </DataContainer>
                    <DataContainer>
                      <Data>{plan2dItemText.type + " : "}</Data>
                      <DataResult>{definitionData.find((x) => x.id == equipment?.definition)?.name || ""}</DataResult>
                    </DataContainer>
                    {
                      (iot && !fromiot) ?
                        <>
                          <DataContainer>
                            <Data>{plan2dItemText.associatediot + " : "}</Data>
                            <DataResultLink onClick={handleOpeniot}>{iot?.name || ""}</DataResultLink>
                          </DataContainer>
                        </>
                        : <>
                        </>

                    }
                    {/* <DataContainer>
                <Data>{plan2dItemText.category + " : "}</Data>
                <DataResult>{definitionData.find((x) => x.id == equipment?.definition)?.category || ""}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{plan2dItemText.deveui + " : "}</Data>
                <DataResult>{iot?.serverproperties?.devEUI || ""}</DataResult>
              </DataContainer>
              <DataContainer>
                <Data>{plan2dItemText.eosprotocol + " : "}</Data>
                <DataResult>{eosprotocoleData.find((x) => x.id == iot?.connectionproperties?.eosprotocol)?.name}</DataResult>
              </DataContainer> */}
                  </DataList>
                </GridItem>
                <GridItem>
                  <TableHeader>
                    <Data>{plan2dItemText.associatedvariables}</Data>
                    <CustomSwitch
                      style={{ margin: "0 0 0 0", display: "flex", alignItems: "center" }}
                      inputTitle={plan2dItemText.showadvanced}
                      checkedState={showadvanced}
                      handleSwitchChange={handleShowadvancedChange}
                    />
                  </TableHeader>
                  <DataTable
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                    noDataComponent={<NoData></NoData>}
                    noHeader={true}
                    columns={pointscolumns}
                    persistTableHead
                    data={showadvanced ? equipmentpoints : equipmentpoints.filter((pt) => !pt.displayproperties?.menuposition || pt.displayproperties?.menuposition === "1")}
                    striped={true}
                    conditionalRowStyles={conditionalRowStyles}
                  //theme="solarized"
                  />
                </GridItem>
              </GridContainer>
              <Dialog
                onClose={handleCloseiot}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={openIot}
              >
                <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseiot}>
                  {iot?.name || ""}
                </CustomDialogTitle>
                <DialogContent dividers>
                  <ViewIotDialog
                    currentiot={iot}
                    iots={iots}
                    equipments={equipments}
                    plan={plan}
                    fullpoints={fullpoints}
                    wpgroup={wpgroup}
                  />
                </DialogContent>
                <DialogActions />
              </Dialog>
              <Dialog
                onClose={handleViewPointClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="sm"
                open={openPoint}
              >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointClose}>
                  Pilotage de {point?.name}
                </CustomDialogTitle>
                <DialogContent dividers>
                  <PointDialog
                    point={point}
                    schedulesData={schedulesData}
                    scriptData={scriptData}
                    chartIdGroup={chartIdGroup}
                    closeModal={handleViewPointClose}
                    refetch={refetchPoint}
                    setNotification={setNotification}
                    equipment={equipment}
                  />
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              <Dialog
                onClose={handleViewPointOverrideClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="sm"
                open={openPointOverride}
              >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleViewPointOverrideClose}>
                  Dérogation de consigne de {point?.name}
                </CustomDialogTitle>
                <DialogContent dividers>
                  <PointOverrideDialog
                    point={point}
                    schedulesData={schedulesData}
                    scriptData={scriptData}
                    chartIdGroup={chartIdGroup}
                    closeModal={handleViewPointOverrideClose}
                    refetch={refetchPoint}
                    setNotification={setNotification}
                    equipment={equipment}
                  />
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              <Dialog
                onClose={handleCloseSchedule}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={openSchedule}
              >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleCloseSchedule}>
                  Modification d'un planning
                </CustomDialogTitle>
                <DialogContent dividers>
                  <ScheduleDialog
                    closeModal={handleCloseSchedule}
                    // setLoading={setLoading}
                    setNotification={setNotification}
                    refetch={refetchSchedules}
                    currentSchedule={currentSchedule}
                    equipmentsdata={equipments}
                    pointsdata={fullpoints}
                  />
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              <Dialog
                onClose={handleCloseScript}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={openScript}
              >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleCloseScript}>
                  Modification d'un script
                </CustomDialogTitle>
                <DialogContent dividers>
                  <ScriptDialog
                    closeModal={handleCloseScript}
                    // setLoading={setLoading}
                    fullpointdata={fullpoints}
                    equipmentdata={equipments}
                    setNotification={setNotification}
                    refetch={refetchSchedules}
                    currentScript={currentScript}
                    wpgroup={workspace?.idgroup}
                    workspaceid={workspace?.id}
                  />
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              {/* Dialogue pour les données d'un élément */}
              <Dialog
                onClose={handleViewPointDataClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="lg"
                open={openPointData}
              >
                <CustomDialogTitle id="addMarket-dialog-title" onClose={handleViewPointDataClose}>
                  {dashboardText.dataof + point?.name}
                </CustomDialogTitle>
                <DialogContent dividers>
                  <ViewPointDataDialog
                    closeModal={handleViewPointDataClose}
                    pointdata={pointdata}
                    planrawdata={planrawdata}
                    plan1ddata={plan1ddata}
                    plan1hdata={plan1hdata}
                    currentPoint={point}
                  />
                </DialogContent>
                <DialogActions />
              </Dialog>
            </form>
          </DialogContent>
      }
    </>
  );
}

export default ViewEquipmentDialog;
